import { Input } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { useCallback, useEffect, useState } from 'react';
import { debounce } from '@mui/material';
import { setParams } from '../../../slices/documentsSlice';

interface DocumentsToolbarInputSearchProps {
    fetchData: () => void;
    onOpenFilters?: () => void;
}

export const DocumentsToolbarInputSearch: React.FC<DocumentsToolbarInputSearchProps> = ({ fetchData, onOpenFilters }) => {
    const dispatch = useAppDispatch();
    const { params } = useAppSelector((state) => state.documents);
    const [searchValue, setSearchValue] = useState('');

    const debouncedSearch = useCallback(
        debounce((value) => {
            dispatch(setParams({ query: value || '' }));
            fetchData();
        }, 500),
        [],
    );

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
        debouncedSearch(e.target.value);
    };

    useEffect(() => {
        setSearchValue(params.query || '');
    }, [params.query]);

    return (
        <Input
            allowClear
            value={searchValue}
            placeholder="Search"
            style={{ width: '20%' }}
            onChange={handleOnChange}
            suffix={<FilterOutlined onClick={onOpenFilters} style={{ cursor: 'pointer' }} />}
        />
    );
};
